import Icon        from "_components/atoms/icon";
import Image       from "_components/atoms/image";
import Typography  from "_components/atoms/typography";
import { tagsObj } from "_components/features/chat/userComment/utils";

import useStyles from "./styles/usernameAndTags";

const UserNameAndTags = ( { data, isStreamer, showDiamondTag } ) => {
	const { classes } = useStyles ( undefined, { name: "user-name-and-tags" } );

	const hasTags = data.tags?.length;

	return (
		<div className = { classes.userName }>

			<a
				className = { classes.anchorTag }
				href = { `/profile/${ data.sportsFan.id }` }
				rel = "noreferrer"
				target = "_blank"
			>
				{data.sportsFan.name}

			</a>

			{data.sportsFan.isCeleb === 1 ? (
				<Icon sameInBothTheme
					className = { classes.svgVerifiedIcon }
					name = "verifiedProfile"
				/>
			) : null}

			{!hasTags ? ":" : ""}

			{data.tags?.map ( tagName => {
				{ /* if user is new streamer then only it will show new user tag */ }
				if ( tagName === "NEW_USER" && !isStreamer )
					return null;

				return (
					<div key = { tagName }
						className = { classes.tagContainer }
					>
						<Image
							alt = ""
							className = { classes.tag }
							src = { tagsObj[tagName] }
						/>
					</div>
				);
			}
			)}

			{showDiamondTag ? <DiamondTagInDonationTab debitValue = { data.debitValue } /> : null}

			{hasTags ? ":" : null}

		</div>
	);
};

const DiamondTagInDonationTab = ( { debitValue } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.diamondAmountContainer }>
			<Icon sameInBothTheme
				className = { classes.diamondSvg }
				name = "diamond"
			/>

			<Typography
				color = { "primary" }
				title = { debitValue }
				variant = "body2"
			/>
		</div>
	);
};

export default UserNameAndTags;
